import { useEffect } from "react";
import carrierOils from ".././files/carrier_oils.json";
import { addDefaultImg } from '../components/imageUtils';


function CarrierOils() {
  useEffect(() => {
    document.title = "Carrier Oils - Deww Botanicals";
  }, []);


  return (
    <>
      {/* // Page Header Start */}
      <div
        className="container-fluid page-header"
        style={{ backgroundImage: `url(../assets/images/carrierOil_banner.jpg)`}}
      >
        <div className="container">
          <h1 className="display-5 mb-3 animated slideInDown">Carrier Oils</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a className="text-body"  Using target="_blank" without rel="noreferrer" href="javascript:void(0);">
                  Home
                </a>
              </li>
              <li className="breadcrumb-item text-dark active" aria-current="page">
                Carrier Oils
              </li>
            </ol>
          </nav>
        </div>
      </div>
      {/* // Page Header End */}

      <div className="container-xxl py-4 py-md-5 container-fluid p-0 mb-5 wow fadeIn">
        <div className="container">
          <div className="row g-0 align-items-end">
            <div className="col-12">
              <p>
                Carrier oils are base oils derived from the fatty parts of
                plants, such as seeds, nuts, or kernels. They are used to dilute
                essential oils before topical application, ensuring safe and
                eﬀective use. Carrier oils provide essential nutrients,
                moisture, and therapeutic benefits to the skin, and are commonly
                used in skincare, massage, and aromatherapy.
              </p>

              <h3>How are Carrier Oils Extracted?</h3>
              <ul>
                <li>
                  Cold Pressing : The most common and preferred method for
                  carrier oils, cold pressing involves mechanically pressing the
                  seeds or nuts without the use of heat. This method preserves
                  the oil's nutrients, vitamins, and fatty acids.
                </li>
                <li>
                  Expeller Pressing : Similar to cold pressing but may involve a
                  slight increase in temperature due to the mechanical friction
                  during extraction. It still maintains the oil's quality and
                  nutritional content.
                </li>
                <li>
                  Solvent Extraction : Uses chemical solvents to extract oil
                  from plant materials. This method is less desirable for
                  high-quality oils as it can leave solvent residues and strip
                  the oil of some of its beneficial properties.
                </li>
              </ul>

              <div className="section-header text-start mb-2 mt-5 ">
                <h2 className="mb-2">Range of Carrier Oils</h2>
                
              </div>
            </div>
          </div>

          <div className="tab-content">
            <div id="tab-1" className="tab-pane fade show p-0 active">
              <div className="row g-4">
                {carrierOils.map((oil, index) => {
                  return (
                    <div
                      className="col-xl-3 col-lg-3 col-md-6 col-6 "
                      key={index}
                    >
                      <div className="product-item h-100">
                        <div className="position-relative bg-light overflow-hidden">
                          <img
                            className="img-fluid w-100"
                            src={oil.image}
                            onError={addDefaultImg}
                            alt={oil.name}
                          />
                          {/* <div className="bg-secondary rounded text-white position-absolute start-0 top-0 m-2 py-1 px-3 nBadge">
                            New
                          </div> */}
                        </div>
                        <div className="text-center p-1 p-md-4 mt-1">
                          <a className="d-block h6 mb-1" Using target="_blank" without rel="noreferrer" href="">
                            {oil.name}
                          </a>
                          <p>{oil.description}</p>
                          {/* <span className="text-primary me-1">$19.00</span>
                          <span className="text-body text-decoration-line-through">
                            $29.00
                          </span> */}
                        </div>
                        {/* <div className="d-flex border-top">
                                    <small className="w-100 text-center py-2">
                                    <Link to="/carrierOils" className="text-body"><i className="fa fa-eye text-primary me-2"></i> View detail</Link>
                                    </small>
                                    <small className="w-50 text-center py-2">
                                        <a className="text-body" Using target="_blank" without rel="noreferrer" href=""><i className="fa fa-shopping-bag text-primary me-2"></i>Add to cart</a>
                                    </small>
                                </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CarrierOils;
